<template>
  <a-tabs v-model="active" :default-active-key="active" @change="(e) => (active = e)" >
    <a-tab-pane :key="1" tab="基本数据">
      <MirrorData v-if="active == 1"></MirrorData>
    </a-tab-pane>
    <a-tab-pane :key="2" tab="跳过原因">
      <JumpData v-if="active == 2" />
    </a-tab-pane>
  </a-tabs>
</template>
<script>
import MirrorData from './MirrorData'
import JumpData from './JumpData'
export default {
  components: { MirrorData, JumpData },
  data() {
    return {
      active: 1,
    }
  },
}
</script>
